import { StrictMode } from "react"
import { createRoot, hydrateRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query"

import { AuthProvider } from "@/components/AuthProvider"
import { initObservability, reportError } from "@/lib/observability"
import App from "./App"
import "./index.css"

initObservability()

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      reportError(error, { source: "query", queryKey: query.queryKey })
    },
  }),
})

const rootElement = document.getElementById("root")!

const app = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
)

// Every route ships real prerendered markup in `#root` -- hydrate it instead
// of wiping and re-rendering from scratch. `createRoot` is the fallback for
// the one route that isn't prerendered (the 404) and for `vite dev`.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app)
} else {
  createRoot(rootElement).render(app)
}
